<template>
    <div class="right w-full xl:max-w-602px lg:max-w-602px max-w-602px md:max-w-none xl:mt-0 lg:mt-0 md:mt-spc50" v-if="img">
        <img class="xl:block lg:block block md:hidden" :src="img" alt="How It Work">
        <img class="rp w-full xl:hidden lg:hidden hidden md:block" :src="rpimg" alt="How it work">
    </div>
</template>

<script>
    export default {
        name: "HowItWorkRight",
        props: ['img','rpimg']
    }
</script>

<style scoped>

</style>